<template>
  <div id="wrap">
    <div class="dashboard clear">
      <Toolbar :menuInfo="menuInfo"></Toolbar>
      <div class="right">
        <Navigation :menuInfo="menuInfo"></Navigation>
        <div class="main">
          <div class="main-nav">
            <ContentsNavigation v-if="true && (menuInfo.company || menuInfo.device)" :menuInfo="menuInfo" @selectNode="selectNode"></ContentsNavigation>
          </div>
          <div class="board clear">
            <TreeView
              :treeType="treeType"
              :treeScope="treeScope"
              :refreshEvent="refreshEvent"
              @selectNode="selectNode"
            ></TreeView>

            <div
              v-if="viewType === 'deviceList' || viewType === 'saleList'"
              class="list"
            >
              <SearchConditions
                @search="search"
              ></SearchConditions>

              <DeviceList
                v-if="viewType === 'deviceList'"
                :company="company"
                :searchCondition="searchCondition"
                :searchEvent="searchEvent"
                :selectEvent="selectEvent"
              ></DeviceList>
              <SaleList
                v-else-if="viewType === 'saleList'"
                :deviceID="deviceID"
                :searchCondition="searchCondition"
                :searchEvent="searchEvent"
                :selectEvent="selectEvent"
              ></SaleList>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-bitwise */
/* eslint-disable no-console */

import Toolbar from '@/components/include/Toolbar';
import Navigation from '@/components/include/Navigation';
import ContentsNavigation from '@/components/include/ContentsNavigation';
import TreeView from '@/components/include/TreeView';
import SearchConditions from '@/components/sale/SearchConditions';
import DeviceList from '@/components/sale/DeviceList';
import SaleList from '@/components/sale/SaleList';

export default {
  components: {
    Toolbar,
    Navigation,
    ContentsNavigation,
    TreeView,
    SearchConditions,
    DeviceList,
    SaleList,
  },
  data: () => ({
    menu: null,
    viewType: 'deviceList',
    company: null,
    companyID: '',
    device: null,
    deviceID: '',
    selectEvent: 0,
    refreshEvent: 0,
    treeType: 'device',
    treeScope: 'biz',
    menuInfo: {
      mainTitle: 'Sale',
      mainName: '매출 분석 관리',
      subTitle: '',
      subName: '',
      company: null,
      division: null,
      device: null,
      tray: null,
      product: null,
    },
    searchCondition: null,
    searchEvent: 0,
  }),
  created() {
    this.menu = this.$route.name;
  },
  methods: {
    selectNode(object, type) {
      if (type === 'company') {
        this.company = object;
        this.device = null;
        this.companyID = object.id;
        this.menuInfo.company = object;
        this.menuInfo.device = null;
        this.viewType = 'deviceList';
        this.selectEvent ^= 1;
      } else if (type === 'device') {
        this.company = null;
        this.device = object;
        this.deviceID = object.id;
        this.menuInfo.company = null;
        this.menuInfo.device = object;
        this.viewType = 'saleList';
        this.selectEvent ^= 1;
      }
    },
    search(condition) {
      this.searchCondition = condition;
      this.searchEvent ^= 1;
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/sale/Sale.vue